<template>
  <div class="recommend-card">
    <template v-if="list.length">
      <Swiper class="swiper" ref="swiper" :options="swiperOptions" @slideChange="handleSwiperChange">
        <SwiperSlide
          class="swiper-slide"
          v-for="(item, index) in list"
          :key="index"
          :style="{ opacity: index < 3 ? 1 : 0 }"
        >
          <CardItem
            ref="cardItem"
            :key="index"
            :index="index"
            :item="item"
            :isShow="playSlideList.includes(index)"
            @click.native="handleBuryCard"
            @contentLoaded="handleContentLoaded"
          />
        </SwiperSlide>
      </Swiper>
      <div class="swiper-home-button-next" @click="handleBuryCard"></div>
      <div class="swiper-home-button-prev" @click="handleBuryCard"></div>
    </template>
    <template v-else>
      <div class="empty">
        <div class="card"></div>
        <div class="card"></div>
        <div class="card"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import CardItem from "./CardItem.vue";

export default {
  name: "RecommendCards",
  components: {
    CardItem,
    Swiper,
    SwiperSlide
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeSwiperIndex: 0,
      swiperOptions: {
        watchSlidesProgress: true,
        threshold: 20,
        initialSlide: 0,
        slidesPerView: 3,
        spaceBetween: 40,
        // centeredSlides: true,
        // loop: true,
        navigation: {
          nextEl: ".swiper-home-button-next",
          prevEl: ".swiper-home-button-prev"
        },
        on: {
          progress: function(progress) {
            for (let i = 0; i < this.slides.length; i++) {
              const slide = this.slides.eq(i);

              const slideProgress = this.slides[i].progress;
              let translateX = slideProgress + "px";
              let translateY = 0;
              let translateZ = 0;
              let scale = 1;
              let rotateX = 0;
              let rotateY = 0;
              let zIndex = 99 - Math.abs(Math.round(10 * slideProgress));
              let opacity = 1;
              if (slideProgress > 0) {
                translateX = slideProgress * 440 - slideProgress * 1.5 * 100 + "px";
                scale = 1 - Math.abs(slideProgress) / 10;
                rotateX = 0;
                rotateY = slideProgress * 10;
                translateZ = -Math.abs(slideProgress) * 100 + "px";
                if (slideProgress > 0 && slideProgress <= 1) {
                  opacity = 1 - slideProgress;
                } else {
                  opacity = 0;
                }
              } else if (slideProgress < -2) {
                translateX = (slideProgress + 2) * 440 - (slideProgress + 2) * 1.5 * 100 + "px";
                scale = 1 - Math.abs(slideProgress + 2) / 10;
                rotateX = 0;
                rotateY = (slideProgress + 2) * 10;
                translateZ = -Math.abs(slideProgress + 2) * 100 + "px";
                if (slideProgress < -2 && slideProgress >= -3) {
                  opacity = 3 - Math.abs(slideProgress);
                } else {
                  opacity = 0;
                }
              }
              slide.transform(
                `translateX(${translateX}) translateY(${translateY}) translateZ(${translateZ}) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", opacity);
            }
          },
          setTransition: function(transition) {
            for (let i = 0; i < this.slides.length; i++) {
              const slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      },
      autoLoopTimer: null,
      playSlideList: [],
      playTimer: null,
      currentPlayCard: null
    };
  },
  watch: {
    playSlideList(val) {
      if (val.length) {
        // this.handleCardPlay(val[0]);
      }
    }
  },
  mounted() {},
  methods: {
    autoLoopSwiper(index = 0) {
      if (this.autoLoopTimer) clearTimeout(this.autoLoopTimer);
      this.autoLoopTimer = setTimeout(() => {
        let nextIndex = index + 1;
        // console.log(nextIndex);
        if (nextIndex >= this.list.length) {
          nextIndex = 0;
        }
        // 切换下一组
        if (this.activeSwiperIndex + 2 == index) {
          this.$refs.swiper.$swiper.slideTo(nextIndex);
        }
        this.autoLoopSwiper(nextIndex);
      }, 3000);
    },
    // 所有card加载完成后启动轮播
    handleContentLoaded(index) {
      if (index === this.list.length - 1) {
        this.autoLoopSwiper();
        // 设置当前显示的card
        this.playSlideList = [0, 1, 2];
      }
    },

    handleCardPlay(index) {
      if (this.playTimer) clearTimeout(this.playTimer);
      // 结束正在play的
      if (this.currentPlayCard) {
        this.currentPlayCard.pauseSpineAnimation();
        this.currentPlayCard = null;
      }
      if (!this.playSlideList.includes(index)) {
        index = this.playSlideList[0];
      }

      const cardItem = this.$refs.cardItem[index];
      if (cardItem && cardItem.isLoadedLive2d) {
        // console.log("CardPlay", index);
        cardItem.playSpineAnimation();
        this.currentPlayCard = cardItem;
        // 2s后结束
        this.playTimer = setTimeout(() => {
          // console.log("CardPlayEnd", index);
          this.handleCardPlay(index + 1);
        }, 2000);
      } else {
        let nextIndex = index + 1;
        if (nextIndex > this.playSlideList[this.playSlideList.length - 1]) {
          nextIndex = this.playSlideList[0];
        }
        const nextCardItem = this.$refs.cardItem[nextIndex];

        if (nextCardItem && nextCardItem.isLoadedLive2d) {
          // console.log("CardPlay", nextIndex);
          nextCardItem.playSpineAnimation();
          this.currentPlayCard = nextCardItem;
          // 2s后结束
          this.playTimer = setTimeout(() => {
            // console.log("CardPlayEnd", index);
            this.handleCardPlay(nextIndex + 1);
          }, 2000);
        } else {
          this.playTimer = setTimeout(() => {
            // console.log("PlayNext", nextIndex);
            this.handleCardPlay(nextIndex);
            this.playTimer = null;
          }, 100);
        }
      }
    },
    handleSwiperChange() {
      this.activeSwiperIndex = this.$refs.swiper.$swiper.activeIndex;

      if (this.activeSwiperIndex + 1 >= this.list.length || this.activeSwiperIndex + 2 >= this.list.length) {
        this.playSlideList = [this.list.length - 3, this.list.length - 2, this.list.length - 1];
      } else {
        this.playSlideList = [this.activeSwiperIndex, this.activeSwiperIndex + 1, this.activeSwiperIndex + 2];
      }

      this.autoLoopSwiper(this.playSlideList[0]);
    },
    handleBuryCard() {
      if (window.staticFn) {
        console.log("点击", "Click_on_new_home_key");
        if (this.$route.name === "wwwNewHome") {
          window.staticFn.customEvent("Click_on_new_home_key");
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.recommend-card {
  position: relative;
  width: 1570px;
  // left: -85px;
  transform: translateX(-85px);
  min-height: 410px;
  &::before {
    content: "";
    display: block;
    width: 85px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background: transparent;
  }
  &::after {
    content: "";
    display: block;
    width: 85px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 99;
    background: transparent;
  }
  .empty {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 58px 85px 43px;
    .card {
      width: 410px;
      height: 600px;
      border-radius: 20px 20px 20px 20px;
      background: #eeeeee;
    }
  }

  .swiper {
    width: 100%;
    padding: 58px 85px 43px;
    // 3d
    perspective: 440px;
    // overflow: visible !important;
    /deep/ .swiper-wrapper {
      transform-style: preserve-3d;
    }
    .swiper-slide {
      width: 440px;
      margin-right: 40px;
      transform-style: preserve-3d;
      transition-property: transform, opacity;
    }
  }

  .swiper-home-button-next {
    position: absolute;
    right: 38px;
    top: 50%;
    z-index: 100;
    transform: translateY(-50%);
    cursor: pointer;
    &.swiper-button-disabled {
      &::after {
        display: none;
      }
    }
    &::after {
      content: "";
      display: block;
      width: 92px;
      height: 92px;
      background: url("~@/assets/images/home-banner-next-icon.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .swiper-home-button-prev {
    position: absolute;
    left: 38px;
    top: 50%;
    z-index: 100;
    transform: translateY(-50%);
    cursor: pointer;
    &.swiper-button-disabled {
      &::after {
        display: none;
      }
    }
    &::after {
      content: "";
      display: block;
      width: 92px;
      height: 92px;
      background: url("~@/assets/images/home-banner-next-icon.png") no-repeat;
      background-size: 100% 100%;
      transform: rotate(180deg);
    }
  }
}
</style>
